module.exports = "https://r.zoocdn.com/_next/static/images/Illustration_valuation-7865f6c420b24c9653c25ea47ac38a51.svg";